import J8Detail from './J8Detail';

export default J8Detail;
